module.exports = __webpack_public_path__ + "img/graph-arrow.3775da8e.svg";